import { ReactElement, FunctionComponent } from "react";

const Logo: FunctionComponent = (props: any): ReactElement => (
  <img alt="Logo" src="/static/logo.svg" {...props} />
);

export default Logo;
